import React from 'react';
import { Alert, Flex, Glyph, Body } from '@edreamsodigeo/prisma-design-system';
import PropTypes from 'prop-types';

export const WarningSign = ({
  warningMessage,
  theme = 'soft',
  type = 'warning',
}) => {
  return (
    <Alert
      theme={theme}
      type={type}
      borderRadius="regular"
      role="alert"
      aria-live="polite"
    >
      <Flex gap="1x_small" alignItems="flex-start">
        <Flex alignItems="flex-start" flexShrink="0">
          <Glyph
            category="Alerts"
            name="Warning"
            size="medium"
            color="warning.90"
            aria-hidden="true"
          />
        </Flex>
        <Body weight="normal" type="small">
          {warningMessage}
        </Body>
      </Flex>
    </Alert>
  );
};

WarningSign.propTypes = {
  warningMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
  theme: PropTypes.oneOf(['soft', 'solid']),
  type: PropTypes.oneOf([
    'warning',
    'positive',
    'informative',
    'critical',
    'neutral',
  ]),
};
